module.exports = __webpack_public_path__ + "media/cycles-start@lg-22d119f2cb3dc7b5eebe859844e03009.jpg";